module.exports = __webpack_public_path__ + "img/item3btn2active.0a28c7a4.png";